export const BASE_URL = "https://timepunch-api.support305.com/api/v1/";

// export const BASE_URL = "http://localhost:8000/api/v1/";
